import { ENDPOINTS } from '@/util/endpoints'
import { HubConnectionBuilder, LogLevel, type HubConnection } from '@microsoft/signalr'
export {
  createDmpChatCancellationMessage,
  DMP_CHAT_CLIENT_TYPE,
  DMP_CHAT_CORRELATION_ID_HEADER,
  createDmpChatTaskBody,
  type DmpChatTaskBody,
} from './dmpChatContract'

const DMP_CHAT_HUB_URL = `${ENDPOINTS.DOTNET}/rest/collaboration-hub`
const RECONNECT_DELAYS = [0, 2000, 5000, 10000, 15000, 30000]

export function createDmpChatConnection(token: string): HubConnection {
  return new HubConnectionBuilder()
    .withUrl(DMP_CHAT_HUB_URL, {
      accessTokenFactory: () => token,
      withCredentials: true,
    })
    .withAutomaticReconnect({
      nextRetryDelayInMilliseconds: (retryContext) =>
        RECONNECT_DELAYS[retryContext.previousRetryCount] ?? RECONNECT_DELAYS[RECONNECT_DELAYS.length - 1],
    })
    .configureLogging(LogLevel.Warning)
    .build()
}
